import * as CONST from "./actionTypes";

export const getVendor = (payload, callBack) => {
  return {
    type: CONST.GET_VENDORS,
    payload,
    callBack,
  };
};

export const getVendorsSuccess = (payload, callBack) => {
  return {
    type: CONST.GET_VENDORS_SUCCESS,
    payload,
    callBack,
  };
};

export const getVendorsFail = (payload, callBack) => {
  return {
    type: CONST.GET_VENDORS_FAIL,
    payload,
    callBack,
  };
};

export const updateVendorList = (payload, callBack) => {
  return {
    type: CONST.UPDATE_VENDORS_LIST,
    payload,
    callBack,
  };
};

export const getVendorById = (payload, callBack) => {
  return {
    type: CONST.GET_VENDORS_BY_ID,
    payload,
    callBack,
  };
};

export const getVendorsByIdSuccess = (payload, callBack) => {
  return {
    type: CONST.GET_VENDORS_BY_ID_SUCCESS,
    payload,
    callBack,
  };
};

export const getVendorsByIdFail = (payload, callBack) => {
  return {
    type: CONST.GET_VENDORS_BY_ID_FAIL,
    payload,
    callBack,
  };
};

export const removeVendor = (payload, callBack) => {
  return {
    type: CONST.REMOVE_VENDOR,
    payload,
    callBack,
  };
};

export const removeVendorSuccess = (payload, callBack) => {
  return {
    type: CONST.REMOVE_VENDOR_SUCCESS,
    payload,
    callBack,
  };
};

export const removeVendorFail = (payload, callBack) => {
  return {
    type: CONST.REMOVE_VENDOR_FAIL,
    payload,
    callBack,
  };
};

export const addVendor = (payload, callBack) => {
  return {
    type: CONST.ADD_VENDOR,
    payload,
    callBack,
  };
};

export const editVendor = (payload, callBack) => {
  return {
    type: CONST.EDIT_VENDOR,
    payload,
    callBack,
  };
};
